import * as types from "../action/ActionType";
import { PER_DIEM_INITIAL } from "../store/InitialStore";
export default function AllPerDiemListReducer(state = PER_DIEM_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.PER_DIEM_LIST:
      return (state = payload);
    default:
      return state;
  }
}
